import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="empty tela-cheia">
      <div className="empty-big">🤔</div>
      <strong>Página não encontrada</strong>
      <p>O link pode ter mudado de endereço.</p>
      <Link className="btn btn-primary" to="/">Voltar pro início</Link>
    </div>
  );
}
